import { useEffect } from "react";
import { toast } from "sonner";

interface UseKeyboardShortcutsProps {
  onCommandOpen: () => void;
  onEscape: () => void;
  isCommandOpen: boolean;
}

export function useKeyboardShortcuts({
  onCommandOpen,
  onEscape,
  isCommandOpen,
}: UseKeyboardShortcutsProps) {
  useEffect(() => {
    const handleKeyDown = (e: globalThis.KeyboardEvent) => {
      // Cmd+K to open command palette
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        onCommandOpen();
      }
      // Escape to close modals
      if (e.key === "Escape") {
        onEscape();
      }
      // ? to show shortcuts toast
      if (e.key === "?" && !isCommandOpen) {
        toast.info("Keyboard Shortcuts", {
          description: "⌘K: Command palette | j/k: Navigate | Enter: Open | Esc: Close",
        });
      }
    };
    globalThis.addEventListener("keydown", handleKeyDown);
    return () => globalThis.removeEventListener("keydown", handleKeyDown);
  }, [onCommandOpen, onEscape, isCommandOpen]);
}
